import SystemMessage from "components/SystemMessage";
import { ErrorCircleColored } from "components/icons/generated";
import LinkButton from "ds/components/Button/LinkButton";
import { getDocsUrl } from "utils/getDocsUrl";

const AccountInactiveError = () => {
  return (
    <SystemMessage
      icon={ErrorCircleColored}
      title="Account is inactive"
      message={
        <>Your account is currently inactive. Please contact our support team to activate it.</>
      }
    >
      <LinkButton
        variant="primary"
        size="medium"
        target="_blank"
        href={getDocsUrl("/product/support")}
      >
        Contact support
      </LinkButton>
    </SystemMessage>
  );
};

export default AccountInactiveError;
